import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import Footer from "../Components/Footer";
import { DEFAULT_LANG } from "../../i18n";
import "../Aboutus/Aboutus.css";
import "./Whoweare.css";
import "./AboutHerings.css";

import ceoPhoto from "../../assets/images/02about_herings_team/new200527/1_1nam.png";

const getLangFromPath = (pathname) => {
  const m = pathname.match(/^\/(kr|en)(\/|$)/);
  return m ? m[1] : DEFAULT_LANG;
};

const renderMultiline = (text) =>
  text.split("\n").map((line, i, arr) => (
    <React.Fragment key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ));

const SOLUTION_ICONS = {
  record: ["M7 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z", "M11 18h2", "M9 9h6", "M9 12h4"],
  connect: ["M3 12h4l2 5 4-10 2 5h6"],
  prove: ["M9 3h6", "M10 3v6l-4 8a2 2 0 0 0 2 3h8a2 2 0 0 0 2-3l-4-8V3", "M7.5 15h9"],
};

const Icon = ({ name }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor"
    strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {SOLUTION_ICONS[name].map((d, i) => (
      <path key={i} d={d} />
    ))}
  </svg>
);

const PROBLEMS = ["daily", "gap", "qol"];
const SOLUTIONS = ["osto", "atti", "healiary"];
const CLINICAL = ["osto", "atti", "healiary"];
const CEO_POINTS = ["now", "career", "edu"];
const CERTS = ["iso", "device", "mdr", "docs"];
const RESEARCH_POINTS = ["design", "trial", "network"];

export default function AboutHerings() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const lang = getLangFromPath(location.pathname);
  const goto = (p) => history.push(`/${lang}${p}`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="abh-root">
      <Menubar slideIndex={0} />
      <Totop />

      <div className="wwa-main-container">
        {/* 배너 */}
        <div className="about-section1">
          <div className="ir_text_section1">
            <p className="ir_maintext1">{t("about.hero.title")}</p>
            <span className="ir_subtext1">{t("about.hero.subtitle")}</span>
          </div>
        </div>

        {/* 우리는 어떤 회사인가 */}
        <section className="abh-intro">
          <div className="abh-wrap">
            <p className="abh-eyebrow">{t("about.intro.eyebrow")}</p>
            <h2 className="abh-intro-highlight">
              {renderMultiline(t("about.intro.highlight"))}
            </h2>
            <p className="abh-intro-body">{t("about.intro.body")}</p>
          </div>
        </section>

        {/* 문제 */}
        <section className="abh-problem">
          <div className="abh-wrap">
            <div className="abh-head">
              <p className="abh-eyebrow">{t("about.problem.eyebrow")}</p>
              <h2 className="abh-h2">{renderMultiline(t("about.problem.title"))}</h2>
            </div>
            <div className="abh-problem-list">
              {PROBLEMS.map((key) => (
                <article className={`abh-stat-card abh-stat-${key}`} key={key}>
                  <p className="abh-stat-phase">{t(`about.problem.items.${key}.phase`)}</p>
                  <p className="abh-stat-value">{t(`about.problem.items.${key}.value`)}</p>
                  <p className="abh-stat-desc">{t(`about.problem.items.${key}.desc`)}</p>
                  <p className="abh-source">{t(`about.problem.items.${key}.source`)}</p>
                </article>
              ))}
            </div>
            <div className="abh-consequence">
              <h3>{t("about.problem.consequence.title")}</h3>
              <p>{t("about.problem.consequence.body")}</p>
              <p className="abh-source">{t("about.problem.consequence.source")}</p>
            </div>
          </div>
        </section>

        {/* 흐름 */}
        <section className="abh-trend">
          <div className="abh-wrap abh-trend-inner">
            <p className="abh-eyebrow abh-eyebrow-light">{t("about.trend.eyebrow")}</p>
            <h2 className="abh-h2 abh-h2-light">{t("about.trend.title")}</h2>
            <p className="abh-lead abh-lead-light abh-trend-body">{t("about.trend.body")}</p>
          </div>
        </section>

        {/* 해결 방식 */}
        <section className="abh-solution">
          <div className="abh-wrap">
            <div className="abh-head">
              <p className="abh-eyebrow">{t("about.solution.eyebrow")}</p>
              <h2 className="abh-h2">{t("about.solution.title")}</h2>
              <p className="abh-lead">{t("about.solution.lead")}</p>
            </div>
            <div className="abh-solution-grid">
              {SOLUTIONS.map((key) => (
                <article className={`abh-solution-card abh-solution-${key}`} key={key}>
                  <p className="abh-solution-phase">
                    {t(`about.solution.items.${key}.phase`)}
                  </p>
                  <h3 className="abh-solution-name">
                    {t(`about.solution.items.${key}.name`)}
                  </h3>
                  <p className="abh-solution-title">
                    {t(`about.solution.items.${key}.title`)}
                  </p>
                  <p className="abh-pillar-desc">
                    {t(`about.solution.items.${key}.desc`)}
                  </p>
                </article>
              ))}
            </div>
            <button className="abh-btn abh-btn-line" onClick={() => goto("/rpmsolution")}>
              {t("about.solution.link")} &rsaquo;
            </button>
          </div>
        </section>

        {/* 결과 · 혜택 */}
        <section className="abh-benefit">
          <div className="abh-wrap">
            <div className="abh-head">
              <p className="abh-eyebrow">{t("about.benefit.eyebrow")}</p>
              <h2 className="abh-h2">{t("about.benefit.title")}</h2>
            </div>
            <div className="abh-benefit-grid">
              {["patient", "clinician"].map((who) => (
                <div className={`abh-benefit-card abh-benefit-${who}`} key={who}>
                  <p className="abh-benefit-label">{t(`about.benefit.${who}.label`)}</p>
                  <ul className="abh-benefit-items">
                    {(t(`about.benefit.${who}.items`, { returnObjects: true }) || []).map(
                      (item, i) => (
                        <li key={i}>{item}</li>
                      )
                    )}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 임상 근거 · 인증 */}
        <section className="abh-evidence">
          <div className="abh-wrap">
            <div className="abh-head">
              <p className="abh-eyebrow">{t("about.evidence.eyebrow")}</p>
              <h2 className="abh-h2">{t("about.evidence.title")}</h2>
            </div>
            <div className="abh-evidence-grid">
              <div>
                <p className="abh-col-label">{t("about.evidence.certLabel")}</p>
                {CERTS.map((key) => (
                  <div className="abh-cert-item" key={key}>
                    <p className="abh-cert-title">{t(`about.evidence.cert.${key}.title`)}</p>
                    <p className="abh-cert-desc">{t(`about.evidence.cert.${key}.desc`)}</p>
                  </div>
                ))}
              </div>
              <div>
                <p className="abh-col-label">{t("about.evidence.clinicalLabel")}</p>
                {CLINICAL.map((key) => (
                  <div className="abh-evidence-item" key={key}>
                    <p className="abh-evidence-name">
                      {t(`about.evidence.clinical.${key}.name`)}
                    </p>
                    <p className="abh-evidence-desc">
                      {renderMultiline(t(`about.evidence.clinical.${key}.desc`))}
                    </p>
                    <p className="abh-source">
                      {t(`about.evidence.clinical.${key}.source`)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 대표이사 */}
        <section className="abh-ceo">
          <div className="abh-wrap">
            <div className="abh-head">
              <p className="abh-eyebrow">{t("about.ceo.eyebrow")}</p>
              <h2 className="abh-h2">{t("about.ceo.title")}</h2>
            </div>
            <div className="wwa-ceo-content">
              <div className="wwa-ceo-photo">
                <img src={ceoPhoto} alt={t("whoweare.ceo.alt")} className="wwa-ceo-img" />
              </div>
              <div className="wwa-ceo-info">
                <p className="wwa-ceo-name">{t("whoweare.ceo.name")}</p>
                <p className="wwa-ceo-role">{t("whoweare.ceo.role")}</p>
                <p className="abh-ceo-body">{t("about.ceo.body")}</p>
                <ul className="abh-ceo-points">
                  {CEO_POINTS.map((key) => (
                    <li key={key}>{t(`about.ceo.points.${key}`)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 임상 연구 역량 */}
        <section className="abh-research">
          <div className="abh-wrap abh-research-inner">
            <div className="abh-research-text">
              <p className="abh-eyebrow">{t("about.research.eyebrow")}</p>
              <h2 className="abh-h2">{t("about.research.title")}</h2>
              <p className="abh-lead abh-research-body">{t("about.research.body")}</p>
              <button className="abh-btn abh-btn-line" onClick={() => goto("/clinicalresearch")}>
                {t("about.research.link")} &rsaquo;
              </button>
            </div>
            <ul className="abh-research-points">
              {RESEARCH_POINTS.map((key) => (
                <li key={key}>{t(`about.research.points.${key}`)}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* 문의 */}
        <section className="abh-cta">
          <div className="abh-wrap">
            <h2 className="abh-cta-title">{t("about.cta.title")}</h2>
            <p className="abh-cta-sub">{t("about.cta.subtitle")}</p>
            <div className="abh-cta-buttons">
              <button className="abh-btn abh-btn-solid" onClick={() => goto("/contactus")}>
                {t("about.cta.contact")}
              </button>
              <button className="abh-btn abh-btn-ghost" onClick={() => goto("/heringsteam")}>
                {t("about.cta.team")}
              </button>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}
